import cloneDeep from "lodash.clonedeep";
import { useCallback, useEffect } from "react";
import isEqual from "react-fast-compare";
import { PaginationFilter } from "../../utils/pagination";
import { FulfilledUpdateMethod, RequestState, REQUEST_STATE } from "../../dataTypes";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { fetchDevelopmentAreas } from "../reducers/fetchDevelopmentAreas";
import { selectRequestState } from "../developmentAreaSelectors";

let filterRef: PaginationFilter | undefined;
let requestStateRef: RequestState | undefined;

const useFetchDevelopmentAreas = () => {
  const dispatch = useAppDispatch();

  const requestState = useAppSelector(selectRequestState);

  if (requestStateRef === undefined) {
    requestStateRef = requestState;
  }

  useEffect(() => {
    requestStateRef = requestState;
  }, [requestState]);

  const loadDevelopmentAreas = useCallback(
    async ({
      filter,
      fulfilledUpdateMethod,
    }: {
      filter?: Readonly<PaginationFilter>;
      fulfilledUpdateMethod: FulfilledUpdateMethod;
    }) => {
      if (!isEqual(filter, filterRef) || requestStateRef !== REQUEST_STATE.PENDING) {
        requestStateRef = REQUEST_STATE.PENDING;
        filterRef = cloneDeep(filter);
        await dispatch(fetchDevelopmentAreas({ filter, fulfilledUpdateMethod }));
      }
    },
    [dispatch],
  );

  return loadDevelopmentAreas;
};

export default useFetchDevelopmentAreas;
